"use strict";

exports.__esModule = true;
exports["default"] = insertAt;
function insertAt(array, index) {
  for (var _len = arguments.length, elementsArray = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    elementsArray[_key - 2] = arguments[_key];
  }
  array.splice.apply(array, [index, 0].concat(elementsArray));
}